import React, { useState, useEffect,useCallback } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Button,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    DragDropContext,
    Droppable,
    Draggable
} from "@hello-pangea/dnd";
import { IoClose } from "react-icons/io5";

import "../../../../css/Administrador/FuncionesGenerales.css"
import { useUserAdmin } from "../../../../admin/UserContext";
import { CrearProductoInicio } from "./CrearProductoHome";
import { EditarProductoSelecion } from "./EditarProductoSelecion";

export const InfoProductoAdminInicio = () => {
    const { Token } = useUserAdmin();
    const [sliders, setSliders] = useState([]);
    const [ModalCrear, setModalCrear] = useState(false)
    const [ModalEditar, setModalEditar] = useState(false)
    const [SliderSelecion, setSliderSelecion] = useState([])
    const backendURL = process.env.REACT_APP_BACKEND_URL;

    const handleAbrirModalEditar = (id) => {
        setSliderSelecion(id)
        setModalEditar(true);
    };
    const handleAbrirCrearSlider = () => {
        setModalCrear(true);
    };
    const fetchSliders = useCallback(async () => {
        try {
          const response = await axios.get(`${backendURL}/api/all/producto/home`, {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          });
          setSliders(response.data.data);
        } catch (error) {
          console.error("Error al obtener sliders:", error);
        }
      }, [Token, backendURL]);
    
      // Llamada inicial a sliders cuando hay token
      useEffect(() => {
        if (Token) {
          fetchSliders();
        }
      }, [Token, fetchSliders]);
   
   

    const handleDragEnd = async (result) => {
        if (!result.destination) return;

        const reordered = Array.from(sliders);
        const [movedItem] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, movedItem);

        setSliders(reordered);

        try {
            // Enviar cada nueva posición al backend
            await Promise.all(
                reordered.map((slider, index) =>
                    axios.post(`${backendURL}/api/editar/producto/home/${slider.id}`, {
                        posicion: index + 1
                    }, {
                        headers: {
                            Authorization: `Bearer ${Token}`,
                        }
                    })
                )
            );
            await fetchSliders()
        } catch (error) {
            console.error("Error al actualizar las posiciones:", error);
        }
    };



    const handleDelete = async (id) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar este banner?')) {
            try {
                 await axios.delete(`${backendURL}/api/productohome/eliminar/${id}`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            });
            
                fetchSliders();
            } catch (error) {
                console.error("Error al eliminar el banner:", error);
                alert("Ocurrió un error al eliminar el banner.");
            }
        }
    };
    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom sx={{ color: "#585857", fontWeight: 600 }}>
                Categoria productos
            </Typography>

            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAbrirCrearSlider}
                sx={{
                    color: "#fff",
                    background: "#5E487B",
                    textTransform: "capitalize",
                    marginTop: "20px",
                    marginBottom: "30px"
                }}
            >
                Crear nueva Categoria
            </Button>

            <TableContainer component={Paper} sx={{ background: '#b2dfdb' }}>
                {sliders.length === 0 ? (
                    <Box p={3} textAlign="center" >
                        <Typography variant="subtitle1" sx={{ color: "#888" }}>
                            No hay sliders agregados.
                        </Typography>
                    </Box>
                ) : (
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="slider-table">
                            {(provided) => (
                                <Table {...provided.droppableProps} ref={provided.innerRef} sx={{ color: '#585857' }}>
                                    <TableHead sx={{ backgroundColor: '#80cbc4' }}>
                                        <TableRow>
                                            <TableCell sx={{ color: '#585857' }}>Posición</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Icono</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Imagen Filtro</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Color</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Titulo</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Titulo uno</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Descripción</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Descripción 1</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Descripción 2</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Descripción 3</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>texto Información</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sliders.map((slider, index) => (
                                            <Draggable key={slider.id} draggableId={slider.id.toString()} index={index}>
                                                {(provided, snapshot) => (
                                                    <TableRow
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        sx={{
                                                            background: snapshot.isDragging ? "#e0e0e0" : "#b2dfdb",
                                                            cursor: "grab"
                                                        }}
                                                    >
                                                        <TableCell sx={{ color: '#585857' }}>{slider.posicion} </TableCell>
                                                        <TableCell>
                                                            {slider.icono && (
                                                                <img
                                                                    src={`${backendURL}/${slider.icono}`}
                                                                    alt="Fondo"
                                                                    style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                         <TableCell sx={{ color: '#585857' }}>
                                                             {slider.imagen_filtro && (
                                                                <img
                                                                    src={`${backendURL}/${slider.imagen_filtro}`}
                                                                    alt="Fondo"
                                                                    style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                />
                                                            )}
                                                         </TableCell>
                                                        <TableCell>
                                                           <div style={{
                                                            width: '80%',
                                                            height: '80px',
                                                            backgroundColor: slider.color,
                                                            border: '1px solid #ccc',
                                                            borderRadius: '4px'
                                                        }}></div>
                                                        </TableCell>
                                                        <TableCell sx={{ color: '#585857', textTransform: 'uppercase',fontWeight:'500' }}>
                                                              {slider.titulo}
                                                        </TableCell>
                                                        <TableCell sx={{ color: '#585857', textTransform: 'uppercase',fontWeight:'500' }}>
                                                              {slider.titulo1}
                                                        </TableCell>
                                                        <TableCell sx={{ color: '#585857', textTransform: 'uppercase',fontWeight:'500' }}>
                                                              {slider.descripcion}
                                                        </TableCell>
                                                        <TableCell sx={{ color: '#585857', textTransform: 'uppercase',fontWeight:'500' }}>
                                                              {slider.descripcion1}
                                                        </TableCell>
                                                        <TableCell sx={{ color: '#585857', textTransform: 'uppercase',fontWeight:'500' }}>
                                                              {slider.descripcion2}
                                                        </TableCell>
                                                        <TableCell sx={{ color: '#585857', textTransform: 'uppercase',fontWeight:'500' }}>
                                                              {slider.descripcion3}
                                                        </TableCell>
                                                        <TableCell sx={{ color: '#585857', textTransform: 'uppercase',fontWeight:'500' }}>
                                                              {slider.texto_informacion}
                                                        </TableCell>
                                                         
                                                        <TableCell>
                                                            <Button
                                                                size="small"

                                                                onClick={() => handleAbrirModalEditar(slider.id)}
                                                                startIcon={<EditIcon />}
                                                                sx={{ marginRight: 1, background: '#ffcc80', color: '#fff', textTransform: "capitalize" }}
                                                            >
                                                                Editar
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                onClick={() => handleDelete(slider.id)}
                                                                startIcon={<DeleteIcon />}
                                                                sx={{ marginRight: 1, background: '#b71c1c', color: '#fff', textTransform: "capitalize" }}
                                                            >
                                                                Eliminar
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </TableBody>
                                </Table>
                            )}
                        </Droppable>
                    </DragDropContext>
                )}
            </TableContainer>

            {/* modal crear slider */}
            <Modal open={ModalCrear} onClose={() => setModalCrear(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalCrear(false)}>
                        <IoClose />
                    </section>
                <CrearProductoInicio fetchSliders={fetchSliders} onclose={() => setModalCrear(false)} /> 

                </Box>
            </Modal>
            {/* Modal editar */}
            <Modal open={ModalEditar} onClose={() => setModalEditar(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalEditar(false)}>
                        <IoClose />
                    </section>
               <EditarProductoSelecion fetchSliders={fetchSliders} slider={SliderSelecion} onclose={() => setModalEditar(false)} /> 

                </Box>
            </Modal>
        </Box>
    );
};